import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
export const CollapsibleContainer = styled.div `
  overflow: hidden;
  max-height: 0;
`;
export const SlideToggle = ({ duration = 300, collapsed = true, children, }) => {
    const [isCollapsed, setIsCollapsed] = useState(collapsed);
    const [toggleState, setToggleState] = useState(collapsed ? 'COLLAPSED' : 'EXPANDED');
    const hasMounted = useRef(false);
    const ref = useRef(null);
    const onToggle = () => {
        setToggleState((prev) => prev === 'COLLAPSED' || prev === 'COLLAPSING' ? 'EXPANDING' : 'COLLAPSING');
        setIsCollapsed(!isCollapsed);
    };
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        if (!hasMounted.current) {
            hasMounted.current = true;
            el.style.maxHeight = '0';
            return;
        }
        if (isCollapsed) {
            el.style.maxHeight = `${el.scrollHeight}px`;
            requestAnimationFrame(() => {
                el.style.transition = `max-height ${duration}ms ease`;
                el.style.maxHeight = '0';
            });
            const timeout = setTimeout(() => {
                setToggleState('COLLAPSED');
            }, duration);
            return () => clearTimeout(timeout);
        }
        else {
            el.style.maxHeight = `${el.scrollHeight}px`;
            el.style.transition = `max-height ${duration}ms ease`;
            const timeout = setTimeout(() => {
                el.style.maxHeight = 'none';
                setToggleState('EXPANDED');
            }, duration);
            return () => clearTimeout(timeout);
        }
    }, [isCollapsed, duration]);
    return (_jsx(_Fragment, { children: children({
            onToggle,
            setCollapsibleElement: (el) => (ref.current = el),
            toggleState,
        }) }));
};
